var map = {
	"./production_holiday_promo_23d_fallback.json": [
		16467,
		6467
	],
	"./production_holiday_promo_3_fallback.json": [
		38444,
		8444
	],
	"./production_holiday_promo_fallback.json": [
		45657,
		5657
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 47127;
module.exports = webpackAsyncContext;